import { Symbol } from "@planningcenter/symbol"
import checkIns from "@planningcenter/icons/sprites/check-ins.svg"
import churchCenter from "@planningcenter/icons/sprites/church-center.svg"
import general from "@planningcenter/icons/sprites/general.svg"
import logomark from "@planningcenter/icons/sprites/logomark.svg"
import people from "@planningcenter/icons/sprites/people.svg"
import publishing from "@planningcenter/icons/sprites/publishing.svg"
import brand from "@planningcenter/icons/sprites/brand.svg"

let icons = {
  brand,
  general,
  "check-ins": checkIns,
  logomark,
  people,
  publishing,
  churchCenter,
}

export function Icon({ symbol: s, pathPrefix = "", ...restProps }) {
  const [collection, symbol] = s.replace(".svg", "").split("#")

  return (
    <Symbol
      symbol={`${pathPrefix}${icons[collection]}#${symbol}`}
      {...restProps}
    />
  )
}
